import {
  IEmailCustomization,
  EventEmailCustomizationMediaType,
} from "modules/emailCustomization/types";
import {
  generateEmailHeader,
  generateEmailFooter,
  generateMediaHtml,
  generateChecklistHtml,
} from "./common";
import { defaultValues } from "./defaults";

export const generateRegistrationConfirmationHtml = (
  customization?: IEmailCustomization,
): string => {
  const headerImageURL =
    customization?.headerImageURL || defaultValues.imageUrl;
  const textBlock1 = customization?.textBlock1 || defaultValues.regTextBlock1;
  const textBlock2 = customization?.textBlock2 || defaultValues.regTextBlock2;
  const textBlock3 = customization?.textBlock3 || defaultValues.regTextBlock3;
  const textBlock4 = customization?.textBlock4 || defaultValues.regTextBlock4;
  const ctaButtonText =
    customization?.ctaButtonText || defaultValues.buttonText;
  const senderImageURL =
    customization?.senderImageURL || defaultValues.senderImageUrl;
  const isImageMedia =
    customization?.mediaType === EventEmailCustomizationMediaType.IMAGE;
  const mediaUrl = customization?.mediaURL || "";
  const mediaExtraImageURL = customization?.mediaExtraImageURL || "";
  const {
    eventUrl,
    eventName,
    eventDateTime,
    userName,
    fromCompanyName,
    videoUrl,
    videoThumbnailUrl,
    geartestUrl,
    guestGuideUrl,
    googleCalendarUrl,
    yahooCalendarUrl,
    outlookCalendarUrl,
    icalCalendarUrl,
  } = defaultValues;

  const textBlock3Html = textBlock3
    ? `<tr><td style="padding: 20px 0 0;"><p style="margin: 0 0 15px 0;">${textBlock3}</p></td></tr>`
    : `<tr><td style="padding: 20px 0 0;">${generateChecklistHtml(
        geartestUrl,
        guestGuideUrl,
      )}</td></tr>`;

  const mediaHtml = generateMediaHtml(
    isImageMedia,
    mediaUrl,
    mediaExtraImageURL,
    videoUrl,
    videoThumbnailUrl,
  );

  return `${generateEmailHeader()}
    <tr>
      <td align="center" style="padding: 0;">
        <img src="${headerImageURL}" alt="${eventName}" style="width: 100%; height: 150px; object-fit: cover;">
      </td>
    </tr>
    <tr>
      <td style="padding: 20px 0;">
        <p style="margin: 0 0 20px 0; font-size: 16px;">Hey ${userName},</p>
        <p style="margin: 0 0 20px 0; font-size: 16px;">${textBlock1}</p>
        <h1 style="margin: 0 0 10px 0; font-size: 24px; color: #1a1a1a; text-align:center">${eventName}</h1>
        <p style="margin: 0 0 20px 0; font-size: 18px; text-align: center;">${eventDateTime}</p>
      </td>
    </tr>
    <tr>
      <td style="padding: 0 0 20px 0;">
        <p style="margin: 0 0 15px 0; text-align: center;">Add it to your calendar</p>
        <div style="text-align: center;">
          <a href="${googleCalendarUrl}" style="display: inline-block; margin: 0 10px;">
            <img border="0" width="30" alt="Google Calendar" data-proportionally-constrained="true" data-responsive="false" src="http://cdn.mcauto-images-production.sendgrid.net/76939b85c448dd04/d780fc4e-8e64-4ea1-a280-7d75117e0547/32x32.png" height="30" style="margin: 0 auto 8px auto;display: block" />
            <p style="margin: 5px 0 0; font-size: 12px;">Google</p>
          </a>
          <a href="${yahooCalendarUrl}" style="display: inline-block; margin: 0 10px;">
            <img border="0" width="30" alt="Yahoo Calendar" data-proportionally-constrained="true" data-responsive="false" src="http://cdn.mcauto-images-production.sendgrid.net/76939b85c448dd04/e4419925-1fb4-4356-b853-45fcb2fd9540/32x32.png" height="30" style="margin: 0 auto 8px auto;display:block" />
            <p style="margin: 5px 0 0; font-size: 12px;">Yahoo</p>
          </a>
          <a href="${outlookCalendarUrl}" style="display: inline-block; margin: 0 10px;">
            <img border="0" width="30" alt="Outlook Calendar" data-proportionally-constrained="true" data-responsive="false" src="http://cdn.mcauto-images-production.sendgrid.net/76939b85c448dd04/19a2ba5c-b818-4924-8152-1af6aa07eea7/32x32.jpg" height="30" style="margin: 0 auto 8px auto;display:block" />
            <p style="margin: 5px 0 0; font-size: 12px;">Outlook</p>
          </a>
          <a href="${icalCalendarUrl}" style="display: inline-block; margin: 0 10px;">
            <img border="0" width="30" alt="iCal Calendar" data-proportionally-constrained="true" data-responsive="false" src="http://cdn.mcauto-images-production.sendgrid.net/76939b85c448dd04/ecbf3184-3f46-4b54-bfff-5c77e1980ccc/32x32.png" height="30" style="margin: 0 auto 8px auto;display:block" />
            <p style="margin: 5px 0 0; font-size: 12px;">iCal</p>
          </a>
        </div>
      </td>
    </tr>
    <tr>
      <td style="padding: 20px 0;">
        <p style="margin: 0 0 15px 0;">${textBlock2}</p>
        <div style="text-align: center;">
          <a href="${eventUrl}" style="display: inline-block; padding: 12px 24px; background-color: #2563EB; color: #ffffff; text-decoration: none; border-radius: 4px; font-weight: bold;">${ctaButtonText}</a>
        </div>
      </td>
    </tr>
    <tr>
      <td style="padding: 0 0 10px;">
        <p style="margin: 0; font-size: 12px; color: #666666;">If you cannot access the button above, click this link: <a href="${eventUrl}" style="color: #2563EB; text-decoration: underline;">${eventUrl}</a></p>
      </td>
    </tr>
    ${textBlock3Html}
    <tr>
      <td style="padding: 20px 0;">
        <p style="margin: 0 0 20px 0;">${textBlock4}</p>
        <div style="text-align: center;">${mediaHtml}</div>
      </td>
    </tr>
    ${generateEmailFooter(fromCompanyName, senderImageURL)}`;
};
